<template>
    <h1>Players</h1>
</template>